import { useTranslation } from "react-i18next";

import Magician from "../../assets/magician.png";
import styles from "./smart-scheduling.module.scss";

export function SmartSchedulingDeclined() {
  const { t } = useTranslation();

  return (
    <div className={styles.smartSchedulingDeclined}>
      <img src={Magician} alt="Magician" />
      <h1>{t("You have declined the smart scheduling successfully")}</h1>
      <p>{t("You can safely close this window now")}</p>
    </div>
  );
}
